import '../Navbar/Navbar.css'
import {Link } from 'react-router-dom'

const Navtab1 = () => {
    return<>

<li className="nav-item dropdown custom-margin1">    
        <a className="nav-link dropdown-toggle" href=" " role="button" data-bs-toggle="dropdown" data-dropdown-id="farmerDropdown" aria-expanded="false" style = {{color: 'white'}}>
        Farmer
        </a>
    <ul className="dropdown-menu">
        <li><a className="dropdown-item" href=" "><Link to='/farmer'><button className='btn'>Green Farm</button></Link></a></li>
        <li>  <hr className="dropdown-divider"/></li>
        <li><a className="dropdown-item" href=" "><Link to='/newcrop'><button className='btn'> New Crop</button></Link></a></li>
        <li>  <hr className="dropdown-divider"/></li>
        <li><a className="dropdown-item" href=" "><Link to='/contractfarming'><button className='btn'> Contract Farming</button></Link></a></li>  
        <li>  <hr className="dropdown-divider"/></li>
        <li><a className="dropdown-item" href=" "><Link to='/leadform'><button className='btn'> registration</button></Link></a></li>
        <li>  <hr className="dropdown-divider"/></li>
        <li><a className="dropdown-item" href=" "><Link to='/search'><button className='btn'> Search Page</button></Link></a></li>  
        <li>  <hr className="dropdown-divider"/></li>
        <li><a className="dropdown-item" href=" "><Link to='/login'><button className='btn'> Login</button></Link></a></li>


    </ul>

    </li>


    {/* <li className="nav-item">
        <a className="nav-link" aria-current="page" href=" " ><Link to='/farmer'style={{color: 'white', textDecoration:'none'}}>Farmer</Link></a>
    </li> */}
    <li className="nav-item custom-margin1">
        <a className="nav-link" aria-current="page" href=" "><Link to='/farmcompany'style={{color: 'white', textDecoration:'none'}}>Farm Enterprise</Link></a>
    </li>


    <li className="nav-item dropdown custom-margin1">    
        <a className="nav-link dropdown-toggle" href=" " role="button" data-bs-toggle="dropdown" data-dropdown-id="digitalAgricultureDropdown" aria-expanded="false" style = {{color: 'white'}}>
        Digital Agriculture
        </a>
    <ul className="dropdown-menu">
        <li><a className="dropdown-item" href=" "><Link to='/traceability'><button className='btn'>Traceability</button></Link></a></li>
        <li>  <hr className="dropdown-divider"/></li>
        <li><a className="dropdown-item" href=" "><Link to='/automation'><button className='btn'> Automation</button></Link></a></li>  
    </ul>
    </li>
</>
};
export default Navtab1;